import {
  useVideoTimeline,
  type PlaybackTransport,
  type VideoTimelineSnapshot,
} from "@carbon6/c6-frontend-design";

// 영상이 준비되기 전에 쓰는 핸들. 재생 위치 0 에 멈춰 있고 아무것도 알리지 않는다.
const IDLE_SNAPSHOT: VideoTimelineSnapshot = {
  playing: false,
  currentTimeSeconds: 0,
  durationSeconds: 0,
  playbackRate: 1,
};
const IDLE_TRANSPORT: Pick<PlaybackTransport, "subscribe" | "getSnapshot"> = {
  subscribe: () => () => undefined,
  getSnapshot: () => IDLE_SNAPSHOT,
};

/**
 * 재생 텔레메트리에서 값 하나만 골라 구독한다. 고른 값이 바뀔 때만 다시 그린다.
 *
 * 재생 중에는 매 프레임 시각이 바뀐다. 그래서 시각 자체가 아니라 "지금 몇 번째 띠인가" 처럼
 * 드물게 바뀌는 값을 고른다. 그러면 에피소드당 다시 그리는 횟수가 띠 수를 넘지 않는다.
 * 영상이 아직 없으면(null) 0초에 멈춘 스냅샷에서 고른다.
 */
export function usePlaybackSelection<T>(
  transport: PlaybackTransport | null,
  selector: (snapshot: VideoTimelineSnapshot) => T,
): T {
  return useVideoTimeline(transport ?? IDLE_TRANSPORT, selector);
}
